module.exports = __webpack_public_path__ + "img/baoxiaomi-head.838fdf23.png";